import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=1885e0cb&scoped=true&"
import script from "./ProductDetail.vue?vue&type=script&lang=js&"
export * from "./ProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&id=1885e0cb&lang=scss&scoped=true&"
import style1 from "./ProductDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1885e0cb",
  null
  
)

export default component.exports